// extracted by mini-css-extract-plugin
export default {"wrapper":"EditOrganizationForm_wrapper__FQk4b","submitWrapper":"EditOrganizationForm_submitWrapper__SxMEk"};